module.exports = __webpack_public_path__ + "static/media/arrow_left.9f41d000.svg";